module.exports = __webpack_public_path__ + "static/media/shape2.pngfeat1.133f8486.png";